import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../globalStyles';

// Cells run top-left, top-right, bottom-left, bottom-right. Which cell a category lights up
// is assigned per category (see CATEGORY_STYLES in TriageCategoryBadge), not derived from axes.
//
// Hidden from assistive tech, because the category it draws is rendered as text beside it and a
// reader should hear the verdict once.
export const TriageMiniMatrix = ({
  activeCell,
  activeColor,
  markerColor,
  size = 42,
}: {
  activeCell: number;
  activeColor: string;
  markerColor: string;
  size?: number;
}) => (
  <MiniMatrixDiv aria-hidden="true" data-testid="triage-mini-matrix" $size={size}>
    {[0, 1, 2, 3].map(cell => (
      <MiniCellDiv key={cell} $active={cell === activeCell} $activeColor={activeColor}>
        {cell === activeCell && (
          <MiniDotDiv $markerColor={markerColor} $size={Math.round(size / 6)} />
        )}
      </MiniCellDiv>
    ))}
  </MiniMatrixDiv>
);

const MATRIX_LINE_COLOR = '#BBBBBB';

const MiniMatrixDiv = styled.div<{ $size: number }>`
  flex-shrink: 0;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  border: 1px solid ${MATRIX_LINE_COLOR};
  border-radius: 6px;
  overflow: hidden;
`;

const MiniCellDiv = styled.div<{ $active: boolean; $activeColor: string }>`
  position: relative;
  background-color: ${({ $active, $activeColor }) => ($active ? $activeColor : colors.white)};
  border-right: 1px solid ${MATRIX_LINE_COLOR};
  border-bottom: 1px solid ${MATRIX_LINE_COLOR};

  &:nth-child(2n) {
    border-right: none;
  }

  &:nth-child(n + 3) {
    border-bottom: none;
  }
`;

const MiniDotDiv = styled.div<{ $markerColor: string; $size: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background-color: ${({ $markerColor }) => $markerColor};
  transform: translate(-50%, -50%);
`;
